type SectionLabelProps = {
  /** Numeral/marker shown before the title, e.g. "04". Defaults to "·" for un-numbered sections. */
  n?: string;
  title: string;
};

/** Numeral + uppercase title + hairline rule, matching the mockup's `.seclabel`. */
export const SectionLabel = ({ n = '·', title }: SectionLabelProps) => (
  <div className="mb-7 flex items-center gap-3.5">
    <span className="font-display text-primary text-[15px] [font-variant-numeric:tabular-nums]">
      {n}
    </span>
    <span className="text-ink-soft text-[11.5px] font-semibold tracking-[.2em] uppercase">
      {title}
    </span>
    <span className="bg-line h-px flex-1" />
  </div>
);
